import { z } from 'zod';
/**
 * A partial-update schema for an object whose create schema carries defaults.
 *
 * Zod's `.partial()` keeps `.default()` wrappers, so an omitted field still
 * parses to its default. For a PATCH that turns "not sent" into "reset", and a
 * one-field change from the admin UI would overwrite stored values. Fields here
 * are optional with their defaults removed, so omitted means unchanged.
 */
export function patchSchema(schema) {
    const shape = Object.fromEntries(Object.entries(schema.shape).map(([key, field]) => {
        const base = field instanceof z.ZodDefault ? field.removeDefault() : field;
        return [key, base.optional()];
    }));
    return z.object(shape);
}
//# sourceMappingURL=patch.js.map